import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { showDate } from '../../constant';

const ViewFinanceReport = () => {
    let navigate = useNavigate();
    const printRef = React.useRef(null);
    let location = useLocation();
    let data = location?.state;
    console.log(data)

    const handleGenratePdf = async () => {
        const input = printRef.current;

        try {
            const canvas = await html2canvas(input);
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: "landscape", // Change orientation to landscape
                unit: "px",
                format: "a4"
            });

            // Load the logo image
            const logoImg = new Image();
            logoImg.src = require('../../Assets/CreArt.png'); // Ensure the path is correct

            logoImg.onload = () => {
                const logoWidth = 100; // Set logo width
                const logoHeight = 30; // Set logo height
                const margin = 20; // Margin for the logo
                const pageWidth = pdf.internal.pageSize.getWidth();

                // Add the logo to the right side of the PDF
                pdf.addImage(logoImg, 'PNG', pageWidth - logoWidth - margin, margin, logoWidth, logoHeight);

                // Add the title closer to the dotted line
                const primaryColor = "#12b0df"; // Define primary color
                pdf.setFont("helvetica", "bold");
                pdf.setFontSize(24); // Increase font size for the title
                pdf.setTextColor(primaryColor);
                pdf.text("Finance Report", margin, margin + logoHeight - 5); // Adjust text position closer to the dotted line

                // Apply primary color to the dotted line
                pdf.setDrawColor(primaryColor); // Set draw color for the line
                pdf.setLineDash([2, 2], 0); // Apply dotted underline
                pdf.line(margin, margin + logoHeight + 10, pageWidth - margin, margin + logoHeight + 10);

                // Add the main content below the title
                const contentY = margin + logoHeight + 25; // Adjust Y position for content
                const width = pageWidth - margin * 2; // Adjust content width
                const height = (canvas.height * width) / canvas.width;

                pdf.setFont("times", "normal");
                pdf.setFontSize(16); // Increase font size for the main content
                pdf.addImage(imgData, 'PNG', margin, contentY, width, height);
                pdf.save("finance-report.pdf");
            };
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    }

    return (
        <div className='grow ms-0 md:ms-0 lg:ms-56 relative'>
            <main className="flex-1 py-8">
                <div className="px-4 mt-20 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div className="lg:flex lg:items-center lg:justify-between">
                        <h1 className="flex-1 min-w-0 text-2xl font-semibold text-gray-900 truncate">
                            Finance Report
                        </h1>
                        <div className="mt-3 sm:flex lg:mt-0 sm:items-center lg:justify-end lg:ml-6 sm:ml-6">
                            <button type="button" className="btn btn-white" onClick={() => navigate('/dashboard/finance-reports/')}>
                                Back
                            </button>
                            <div title="Save Progress" className="mt-4 sm:mt-0 ml-4 btn btn-primary leading-icon" role="button" /* onClick={downloadPdf} */ onClick={handleGenratePdf}>
                                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Download
                            </div>
                        </div>
                    </div>
                    <div ref={printRef} className="mt-5 overflow-hidden bg-white divide-y divide-gray-200 rounded-lg shadow">
                        <div className="px-4 py-5 sm:p-6">
                            <h2 className ="text-base tracking-wide text-gray-600 uppercase">
                                Report From - {showDate(data.start_date)}  To  {showDate(data.end_date)}
                            </h2>

                            <div className="grid grid-cols-1 gap-5 mt-5 md:grid-cols-2">
                                <div>
                                    <div>
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                New Enrollments - {data.new_admissions} Enrollments
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div>
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Fresh Business - {data.fresh_business} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="px-4 py-5 sm:p-6">
                            <h2 className="text-base tracking-wide text-gray-600 uppercase">
                                Collection Report
                            </h2>

                            <div className="grid grid-cols-1 gap-5 mt-5 md:grid-cols-2">
                                <div className="">
                                    <div>
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Total Collection - {data.total_collection} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-5 mt-3 md:grid-cols-2">
                                <div className="">
                                    <div className="mt-4 text-xl tracking-wide text-gray-600 uppercase">
                                        Payment Method
                                    </div>
                                </div>
                                <div className="">
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Cash - {data.cash} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Cheque - {data.cheque} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Google Pay - {data.google_pay} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Phone Pay - {data.phone_pe} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Net Banking - {data.net_banking} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                UPI - {data.upi} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="mt-4">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Paytm - {data.paytm} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="px-4 py-5 sm:p-6">
                            <div className="grid grid-cols-1 gap-5 mt-5 md:grid-cols-2">
                                <div className="">
                                    <h2 className="text-base tracking-wide text-gray-600 uppercase">
                                        Summery Report
                                    </h2>
                                    <div className="mt-1">
                                        <ul className=" list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                Total Expense - {data.total_expense} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="">
                                    <h2 className="text-base tracking-wide text-gray-600 uppercase">
                                        Total Savings
                                    </h2>
                                    <div className="mt-1">
                                        <ul className="list-inside">
                                            <li className="text-xl font-medium text-gray-900">
                                                On Hand Collection - {data.total_collection - data.total_expense} Rs.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ViewFinanceReport
